import React from 'react';
import './../App.css';
import BlueTicket from '../Components/BlueTicket';
import Search from '../Components/Search';
import Article from '../Components/Article';
import Editor from '../Components/Editor';
import SideBar from '../Components/SideBar';
import methodsOneContext from '../Contexts/MethodsOne';
import GoodsContainer from '../Components/GoodsContainer'
import PartialSite1 from '../Components/PartialSite1';
import ScrollAnimation from 'react-animate-on-scroll';


export default class App extends React.Component {
  constructor(props) {
    super(props);
    console.log(this.props.history.location.pathname);
  }

  state = {
    detailList: [],
    editId: -1
  }

  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }

  setDetailList(data) {

    this.setState(prevState => {
      return {
        detailList: data,
        editId: -1
      }
    })

  }

  editDetail(id) {
    this.setState(prevState => {
      return {
        editId: id
      }
    })
  }

  newEvent() {
    this.setState(prevState => {
      return {
        detailList: [{ Id: 0, Description: '', Tag: '' }],
        editId: 0
      }
    })

    console.log('رسsadadsadیدم');
    console.log(this.state);
    console.log(this.state.detailList);

  }

  render() {
    let detailList = this.state.detailList;
    let editId = this.state.editId;
    return (

      <>

        <div class="header_section">
          <div class="maz-bg-container ">
            <div class="container">
              <ScrollAnimation animateIn="fadeIn">
                <section class="maz-textSection clearfix">
                  <article>
                    <div class="row add-txt ">
                      <div class="maz-col-xs-12 col-sm-6">
                        <div class="row">
                          <div class="maz-col-xs-12">

                            <div class="txt">
                              <div class="icon-location"></div>
                                        نشانی شرکت :
میدان ولیعصر،خیابان شقایق،کوچه سوم، کوچه نصر پلاک 8،واحد 4
                                    </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="maz-col-xs-12">

                            <div class="txt">
                              <div class="icon-tel"></div>
                                        تلفن مشاوره  :
                                        <span class="fa-txt">۰۹۱۲۴۵۴۱۲۳۱</span>
                            </div>
                          </div>
                        </div> 
                        <div class="row">
                          <div class="maz-col-xs-12">

                            <div class="txt">
                              <div class="icon-tel"></div>
                                        تلفن شعبه مرکزی :
                                        <span class="fa-txt">۸۸۸۰۲۵۹۴-۰۲۱</span>
                            </div>
                          </div>
                        </div>    
                        <div class="row">
                          <div class="maz-col-xs-12">

                            <div class="txt">
                              <div class="icon-tel"></div>
                                        تلفن شعبه کرج :
                                        <span class="fa-txt">۳۴۹۱۳۹۲۸-۰۲۶</span>
                            </div>
                          </div>
                        </div>          
                        <div class="row">
                          <div class="maz-col-xs-12">

                            <div class="txt">
                              <div class="icon-time"></div>
                                        ساعت کاری :
                                        <span class="fa-txt">١٦:٣٠ - ٨:٣٠</span>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="maz-col-xs-12">

                            <div class="txt">
                              <div class="icon-post"></div>
                                        کد پستی :
                                        <span class="fa-txt">۱۳۴۶۶۶۴۵۷۴</span>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="maz-col-xs-12">

                            <div class="txt">
                              <div class="icon-post"></div>
                                        شناسه ملی :
                                        <span class="fa-txt">١٠١٠٢١١٠٣٤٨
                                        </span>
                            </div>
                          </div>
                        </div>
                
                      </div>



                      <div class="maz-col-xs-12 col-sm-6">

                        <div class="row">
                          <div class="maz-col-xs-12">

                            <div class="txt">
                              <div class="icon-email"></div>
                                        پشتیبانی فنی :
                                        <span class="en-txt">support@bitkala.ir</span>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="maz-col-xs-12">

                            <div class="txt">
                              <div class="icon-email"></div>
                                          مدیر عامل :
                                        <span class="en-txt">info@bitkala.ir</span>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="maz-col-xs-12">

                            <div class="txt">
                              <div class="icon-email"></div>
                                        ارتباط با مشتریان و فروش :
                                        <span class="en-txt">pr@bitkala.ir</span>
                            </div>
                          </div>
                        </div>


                        <div class="row">
                          <div class="maz-col-xs-12">

                            <div class="txt">
                              <div class="icon-email"></div>
                                        اداری :
                                        <span class="en-txt">office@bitkala.ir</span>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="maz-col-xs-12">
                            <div class="txt">
                              <div class="icon-email"></div>
                                        مالی :
                                        <span class="en-txt">financial@bitkala.ir</span>
                            </div>
                          </div>

                          <div class="maz-col-xs-12">
                            <div class="txt">
                              <div class="icon-email"></div>
                                        منابع انسانی :
                                        <span class="en-txt">hr@bitkala.ir</span>
                            </div>
                          </div>

                          <div class="maz-col-xs-12">
                            <div class="txt">
                              <div class="icon-email"></div>
                                        ارسال رزومه جهت همکاری :
                                        <span class="en-txt">jobs@bitkala.ir</span>
                            </div>
                          </div>


                        </div>
                      </div>
                    </div>

                  </article>
                </section>
              </ScrollAnimation>
            </div>
          </div>
        </div>

      </>
    )
  }
}


